import { hasSavedMultisafes } from './hasSavedMultisafes';
import { isNearWallet } from './isNearWallet';

export const selectors = {
    hasSavedMultisafes,
    isNearWallet,
};
